<template>
  <div class="container">
    <p>Wandelen vereist een minimale resolutie van 1024x768 pixels.</p>
  </div>
</template>

<script>
export default { name: 'NotSupportedView' }
</script>

<style scoped lang="scss">
.container { text-align: center; }
</style>
